// extracted by mini-css-extract-plugin
module.exports = {"loading-mochi":"loading-mochi_loading-mochi__vGkMN","show":"loading-mochi_show__AAEjN"};